import React from 'react'
import PropTypes from 'prop-types'
import { AppBar, Toolbar, Avatar, Box, Typography, Select, MenuItem } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

import { styles } from '../../classes/Styles'

class RediscoverHeaderComponent extends React.Component {
  static propTypes = {
    homepage: PropTypes.object,
    history: PropTypes.object,
    selectedNetwork: PropTypes.string,
    updateSelectedNetwork: PropTypes.func,
    shortcut: PropTypes.shape({
      id: PropTypes.string.isRequired,
      expires_at: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
      target_id: PropTypes.string.isRequired
    })
  }

  changeNetwork = (id, name) => {
    this.props.updateSelectedNetwork(name)
    this.props.history.push(`/insights/rediscover/${id}`)
  }

  render () {
    const { homepage } = this.props
    let rediscoverNetworks = homepage.details && homepage.details.discover_entities.sort((a, b) => (a.network_label < b.network_label) ? -1 : (a.network_label > b.network_label) ? 1 : 0)
    const primaryNetwork = this.props.selectedNetwork
    return (
      <AppBar position="static" color="transparent" elevation={0} className="header">
        <Toolbar disableGutters={true} justify="center">
          <Avatar alt="Page title icon" src="/static/images/compass.png" variant="square" className="rediscoverImgThumb"></Avatar>
          { (this.props.shortcut || (rediscoverNetworks && rediscoverNetworks.length === 1)) &&
            <Box pl={1} className='shortcutTitle'>
              <Typography>
                <span className="title mb-0">{primaryNetwork} Content Analysis</span>
              </Typography>
            </Box>
          }
          { (!this.props.shortcut && (rediscoverNetworks && rediscoverNetworks.length > 1)) &&
            <Box pl={1}>
              <Select
                value={primaryNetwork}
                >
                { rediscoverNetworks && rediscoverNetworks.map(entity => {
                  return (
                    <MenuItem value={entity.network_label} key={entity.entity_id} onClick={() => this.changeNetwork(entity.entity_id, entity.network_label)}>
                      <span className="title mb-0">{entity.network_label} Content Analysis</span>
                    </MenuItem>
                  )
                })}
              </Select>
            </Box>
          }
        </Toolbar>
      </AppBar>
    )
  }
}

export default withStyles(styles)(RediscoverHeaderComponent)
